"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterHeader = FilterHeader;
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _closeButton = require("@design/ui/close-button");
var _dropdownMenu = require("@design/ui/dropdown-menu");
var _searchInput = require("@design/ui/search-input");
var _jsxRuntime = require("react/jsx-runtime");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function toggleValue(values, value) {
  return values.includes(value) ? values.filter(function (current) {
    return current !== value;
  }) : [].concat(_toConsumableArray(values), [value]);
}
function FilterHeader(_ref) {
  var searchQuery = _ref.searchQuery,
    onSearchQueryChange = _ref.onSearchQueryChange,
    searchPlaceholder = _ref.searchPlaceholder,
    filterSections = _ref.filterSections,
    onClose = _ref.onClose;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex items-center gap-2 border-b border-border-default",
    "data-sentry-component": "FilterHeader",
    "data-sentry-source-file": "filter-header.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_searchInput.SearchInput, {
      className: "flex-1 border-b-0",
      placeholder: searchPlaceholder,
      value: searchQuery,
      onValueChange: onSearchQueryChange,
      "data-sentry-element": "SearchInput",
      "data-sentry-source-file": "filter-header.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex items-center gap-0.5 pr-2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenu, {
        "data-sentry-element": "DropdownMenu",
        "data-sentry-source-file": "filter-header.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuTrigger, {
          asChild: true,
          "data-sentry-element": "DropdownMenuTrigger",
          "data-sentry-source-file": "filter-header.tsx",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            variant: "ghost",
            size: "icon-sm",
            "aria-label": "Filter",
            "data-sentry-element": "Button",
            "data-sentry-source-file": "filter-header.tsx",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.FilterAltIcon, {
              "data-sentry-element": "FilterAltIcon",
              "data-sentry-source-file": "filter-header.tsx"
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuContent, {
          align: "end",
          className: "w-56",
          "data-sentry-element": "DropdownMenuContent",
          "data-sentry-source-file": "filter-header.tsx",
          children: filterSections.map(function (section) {
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenuGroup, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuLabel, {
                children: section.title
              }), section.options.map(function (option) {
                return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuCheckboxItem, {
                  checked: section.selectedValues.includes(option.value),
                  onCheckedChange: function onCheckedChange() {
                    return section.onSelectedValuesChange(toggleValue(section.selectedValues, option.value));
                  },
                  onSelect: function onSelect(event) {
                    return event.preventDefault();
                  },
                  children: option.label
                }, option.value);
              })]
            }, section.title);
          })
        })]
      }), onClose && /*#__PURE__*/(0, _jsxRuntime.jsx)(_closeButton.CloseButton, {
        onClick: onClose
      })]
    })]
  });
}